import React from "react";
// import "./loaderBtn.css";

const LoaderBtnContact = () => {
  return <div className={`w-6 h-6 rounded-full animate-spin border-[3px] border-solid border-white border-b-transparent`}></div>;
};

export default LoaderBtnContact;
